<template>
  <div class="row">
    <div class="col-lg-2 col-md-3 private-project-border" style="max-height: 750px;overflow-y: scroll;">
      <div class="row mb-2 pb-3" style="border-bottom: 1px solid #f3f3f3" >
        <div class="input-group">
          <span class="input-group-text"><font-awesome-icon icon="filter"  style="color: #1e3e67"/></span>
          <input v-model="searchText" placeholder="Search Project" class="align-items-sm-center form-control" type="search">
        </div>
      </div>
      <div class="accordion" id="accordionExample">
        <div class="accordion-item" v-for="(userProject, index) in userProjects" :key="userProject.id"
             :style="{border: userProject.projectId == selectedProjectId ? '1px solid #56759c' : '',
                     background: userProject.projectId == selectedProjectId ? '#f2f6f9' : ''}">
          <h2 class="accordion-header" id="headingOne">
            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#collapseOne_' + index" aria-expanded="false"
                    @click="goToRoles(userProject.projectId)">
              <span style="font-size: 14px">{{userProject.projectName}}</span>
            </button>
          </h2>
          <div :id="'collapseOne_' + index" class="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
            <div class="accordion-body">
              <div class="accordion">
                <div v-if="userProject.projectId == selectedProjectId && rolesOfProject.length > 0">
                  <span >Roles</span>
                  <div v-for="roleProj in rolesOfProject " :key="roleProj.id" class="mt-2">
                    <ul style="list-style: circle" class="mx-3">
                      <li>
                        <div class="notIcon groupName" type="button" @click="goToUserProjectRoles(roleProj.id)"
                             :style="{textDecoration: roleProj.id == selectedRoleId ? 'underline' : '',
                                          textUnderlinePosition:roleProj.id == selectedRoleId ? 'under' : ''}">
                          {{roleProj.roleName}}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-md-12 mx-lg-2 col-lg-9">
        <div class="row dashboard-border">
          <div class="col-md-3 col-5 align-self-center" >
            <img src="../../assets/icons/projects.png" height="32" width="32"/>
            <span class="mx-2"> Users </span>
          </div>
          <div class="col-md-9 col-7 text-end align-self-center">
            <button class="btn" type="button" data-bs-toggle="modal" data-bs-target="#addUserRole" style="background-color: #56759c;color:#ffffff" @click="openCloseUserRoleModal()">
              <font-awesome-icon icon="plus-circle" /><span style="color: #ffffff;font-weight: unset" class="mx-1"> Add User</span>
            </button>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="row modified-table mt-3 table-responsive">
              <table class="table table-bordered table-font table-striped table-scroll" id="DynamicTable">
                <thead>
                <tr>
                  <th>User Name</th>
                  <th>Email</th>
                  <th></th>
                </tr>
                </thead>
                <tbody v-if="rolesOfProject.length > 0" >
                  <tr v-for="item in userRoles" :key="item.id">
                    <td>
                      {{item.fullName}}
                    </td>
                    <td>
                      {{item.email}}
                    </td>
                    <td>
                      <font-awesome-icon @click="TryDeleteUserRole(item.id,item.fullName)"
                                         icon="trash-alt"
                                         size="lg" class="modified-color-red button-hover"
                                         style="cursor: pointer"
                                         title="Add role this user"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div class="col-12 my" v-if="userRoles.length < 1 || rolesOfProject.length < 1  "  style="text-align: center">
                <p style="font-size: 18px;">No results found!</p>
              </div>
            </div>
          </div>
        </div>
    </div>
    <add-user-role :projectId='selectedProjectId' :role-id="selectedRoleId" :isActiveUserRoleModal='isActiveUserRoleModal'
                   @openCloseUserRoleModal="openCloseUserRoleModal" :user-id='userProject.idUser'
    />
  </div>
</template>
<script>

  import {loadingMixin} from "../../utils/mixins";
  import AddUserRole from "../../components/ui/AddUserRole";
  import {mapActions, mapState} from "vuex";

  export default {
    name: "UserRole",
    mixins: [loadingMixin],
    components: {
      AddUserRole,
    },
    data() {
      return {
        userForm: {
          userId:0,
          projectId: 0
        },
        active: false,
        selectedProjectId: 0,
        isActiveUserRoleModal: false,
        selectedUsers: [],
        //selectedUserId: 0,
        selectedRoleId:0,
        searchText:""
      }
    },

    methods: {
      ...mapActions('projects', ['getProjects', 'getProject', 'getUserProject', 'addUserProject', 'addProject', 'openCloseProjectModal', 'deleteUser']),
      ...mapActions('users', ['getUsers']),
      ...mapActions('roles', ['getRoles', 'getRolesOfProject','getUserRoles' , 'deleteUserRole']),

      openCloseUserRoleModal() {
        this.isActiveUserRoleModal = !this.isActiveUserRoleModal;
        //this.selectedUsers = [];
      },
      goToRoles(id) {
        this.selectedProjectId =id;
        this.getRolesOfProject(this.selectedProjectId)
        this.getUserProject(this.selectedProjectId)
      },

      goToUserProjectRoles(id) {
        this.selectedRoleId = id;
        this.getUserRoles({id:this.selectedRoleId});
      },
      isProjectIcon(value) {
        let fileList = []
        const illustrations = require.context(
            '@/assets/projectIcon',
            true
        )
        fileList = illustrations.keys()
        // console.log(fileList)
        let searcText = './' + value + '.png'
        if (fileList.includes(searcText)) {
          return true;
        } else {
          return false;
        }
      },

      TryDeleteUserRole(id, name) {
        this.$swal({
          title: '<p style="font-size: 22px; font-family: ui-sans-serif;text-align: center">You are about to delete role "' + name + '" Are you sure?</p>',
          html: "",
          showCancelButton: true,
          cancelButtonText: 'No',
          cancelButtonColor: '#ec2929d4',
          confirmButtonColor: '#1e3e67',
          confirmButtonText: 'Yes',
        }).then(async (response) => {
          if (response.value) {
            try {
              await this.deleteUserRole(id);
              this.$notify({
                title: "Success",
                text: "User role  deleted deleted successfully. ",
                type: "success"
              });

            } catch (e) {
              this.$notify({
                title: "Error",
                text: "Failed to delete user role.." + e.message,
                type: "error"
              });
            }
          }
        });
      },

    },

    computed: {
      ...mapState('roles', ['roles', 'userRoles' , 'rolesOfProject', 'userProjectRoles']),
      ...mapState('projects', ['projects', 'project', 'userProject', 'isActiveProjectModal']),

      userProjects: function () {
        return this.projects.filter((post) => {
          return post.projectName.toUpperCase().match(this.searchText.toUpperCase()) && post.isPrivate == false && post.projectCode != 'SER' && post.projectCode != 'TUR' && post.projectCode != 'FLY'
              && post.projectCode != 'ITS' && post.projectCode != 'MAP' && post.projectCode != 'OUT' || post.projectCode == 'AUT'
               ;
        });
      },
    },
    async created() {
      this.showLoading();
      try {
        await this.getProjects();
      } finally {
        this.hideLoading();
      }
    },
  }
</script>

<style scoped>
  .private-project-border{
    padding:12px;
    box-shadow: 0px 3px 10px #ced4da;
    cursor: pointer;
  }
  ul {
    padding: 0;
  }
   ul li {
    font-size: 14px;
  }
  .header {
   font-size: 20px;
   color: #383838;
   font-weight: 500;
   font-family: Helvetica, Arial;
  }
  .card-hover:hover {
    box-shadow: 0px 3px 10px #8d8d95 !important;
  }
  .accordion-item{
    margin-bottom: 5px;
  }
  .accordion-button{
    height: 40px;
  }
  .accordion-item:not(:first-of-type) {
    border: 1px solid #dee2e6;
  }
  .accordion-button:focus {
    box-shadow: unset;
  }
  .accordion-button:not(.collapsed)::before {
    background-image: var(--bs-accordion-btn-active-icon);
    transform: rotate(-180deg);;
  }
  .accordion-button:not(.collapsed){
    background-color: unset;
    color: #56759c;
    box-shadow: inset 0 calc(-1 * 1px) 0 #dee2e6;
  }
  .accordion-button::before {
    margin-right: 10px;
    flex-shrink: 0;
    width: 1.25rem;
    height: 1.25rem;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: 1.25rem;
    transition: transform 0.2s ease-in-out;
  }
  .accordion-button::after {
    display: none;
  }
  .notIcon::before{
    display: none;
  }
  .groupName:hover{
    text-decoration: underline;
    text-underline-position: under;
  }
</style>
